import * as React from 'react';

export default ({ viewBox, style }) => (
  <svg width="40" height="40" viewBox={viewBox} style={style}>
    <path d="M39.733 33.273H0V6.667h39.733L31.412 19.97l8.321 13.303" />
  </svg>
);
